import { ApiResponseObject } from "../../types";
import { axios } from "../../utils/axios";
import { IKategorijaZaZahtevProps } from "../obligee/exciseStamps/exciseStamps.types";
import {
  DetaljiOSkladistu,
  DetaljiZahtevaDozvole,
  IDetaljiOSkladistaPayload,
  IDetaljiZahtevaDozvolePayload,
  IDohvatiDokumentPayload,
  IDohvatiDokumentProps,
  IDokumentResenjaProps,
  IMfIzdavanjeResenjaOOduzimanjuPayload,
  IMfIzdavanjeResenjaPayload,
  IMfListaAkciznihDozvolaProps,
  IMfListaAkciznihSkladistaProps,
  IMfMarkcieVraceneInsertUnistenjePayload,
  IMfMarkiceVraceneCreateOrUpdatePayload,
  IMfObradiZahtevZaDozvoluPayload,
  IMfObradiZahtevZaMarkicu,
  IMfSveMarkiceVracenihPayload,
  IMfSveMarkiceVracenihResponse,
  IMfSviZahteviZaMarkicuProps,
  IPoreskaDokumentDohvatiPayload,
  IZahtevMarkiceIdProps,
  IZahtevaDozvolePayload,
  MfinExciseLicenceRequestListPayload,
  MfinExciseStampRequestListPayload,
  MfinExciseWarehouseListPayload,
  MfinListaEvidentiranihAkciznihMarkicaPayload,
  MfinListaEvidentiranihAkciznihMarkicaResponse,
  NapravljenZahtevZaMarkicuMFin,
} from "./ministry.types";

const postMfSviZahteviZaMarkicu = (
  payload: Partial<MfinExciseStampRequestListPayload>
): Promise<ApiResponseObject<IMfSviZahteviZaMarkicuProps>> => {
  return axios.post("/mfin/mfSviZahteviZaMarkicu", payload);
};

const postMfListaAkciznihSkladista = (
  payload: MfinExciseWarehouseListPayload
): Promise<ApiResponseObject<IMfListaAkciznihSkladistaProps>> => {
  return axios.post("/mfin/mfListaAkciznihSkladista", payload);
};

// duplicate in exciseStamps
const postInformacijeNapravljenogZahtevaZaMarkicu = (
  payload: IZahtevMarkiceIdProps
): Promise<ApiResponseObject<NapravljenZahtevZaMarkicuMFin>> => {
  return axios.post("/informacijeNapravljenogZahtevaZaMarkicu", payload);
};

const postMfObradiZahtevZaMarkicu = (
  payload: IMfObradiZahtevZaMarkicu
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/mfin/mfObradiZahtevZaMarkicu", payload);
};

const postDetaljiOSkladistu = (
  payload: IDetaljiOSkladistaPayload
): Promise<ApiResponseObject<DetaljiOSkladistu>> => {
  return axios.post("/mfin/detaljiOSkladistu", payload);
};

const postMfObradiZahtevZaDozvolu = (
  payload: IMfObradiZahtevZaDozvoluPayload
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/mfin/mfObradiZahtevZaDozvolu", payload);
};

const createDohvatiDokument = (
  payload: IDohvatiDokumentPayload
): Promise<ApiResponseObject<IDohvatiDokumentProps>> => {
  return axios.post("/mfin/dohvatiDokument", payload);
};

const createDohvatiDokumentMfin = (
  payload: IDohvatiDokumentPayload
): Promise<ApiResponseObject<IDohvatiDokumentProps>> => {
  return axios.post("/mfin/dohvatiDokumentMfin", payload);
};

const createMfListaAkciznihDozvola = (
  payload: MfinExciseLicenceRequestListPayload
): Promise<ApiResponseObject<IMfListaAkciznihDozvolaProps>> => {
  return axios.post("/mfin/mfListaAkciznihDozvola", payload);
};

const createDetaljiZahtevaDozvole = (
  payload: IDetaljiZahtevaDozvolePayload
): Promise<ApiResponseObject<DetaljiZahtevaDozvole>> => {
  return axios.post("/detaljiZahtevaDozvole", payload);
};

const createMfIzdavanjeResenja = (
  payload: IMfIzdavanjeResenjaPayload
): Promise<ApiResponseObject<number | null>> => {
  const validParams = {
    ...payload,
    dokumentResenja: {
      ...payload.dokumentResenja,
      format: payload.dokumentResenja?.format || "pdf",
    },
  };
  return axios.post("/mfin/mfIzdavanjeResenja", validParams);
};

const poreskaDohvatiDokument = (
  payload: IPoreskaDokumentDohvatiPayload
): Promise<ApiResponseObject<IDokumentResenjaProps>> => {
  return axios.post("/mfin/dohvatiDokumentPoreske", payload);
};

const createMfIzdavanjeResenjaOOduzimanju = (
  payload: IMfIzdavanjeResenjaOOduzimanjuPayload
): Promise<ApiResponseObject<number>> => {
  return axios.post("/mfin/mfIzdavanjeResenjaOOduzimanju", payload);
};

const generisiDozvolaZahtevDokument = (
  payload: IZahtevaDozvolePayload
): Promise<ApiResponseObject<{ content: string }>> => {
  return axios.post("/mfin/generisiDozvolaZahtevDokument", payload);
};

const postMfSveMarkiceVracenih = (
  payload: IMfSveMarkiceVracenihPayload
): Promise<ApiResponseObject<IMfSveMarkiceVracenihResponse[]>> => {
  return axios.post("/mfin/mfSveVraceneMarkice", payload);
};

const postMfMarkiceVraceneCreateOrUpdate = (
  payload: IMfMarkiceVraceneCreateOrUpdatePayload
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/mfin/mfMarkiceVraceneCreateOrUpdate", payload);
};

const postMfMarkcieVraceneInsertUnistenje = (
  payload: IMfMarkcieVraceneInsertUnistenjePayload
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/mfin/mfMarkcieVraceneInsertUnistenje", payload);
};

const postMfMarkiceVraceneDelete = (payload: {
  id: number;
}): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/mfin/mfMarkiceVraceneDelete", payload);
};

const getMfListaKategorijaZaZahtev = (
  brojZahteva: string
): Promise<ApiResponseObject<Array<IKategorijaZaZahtevProps>>> => {
  return axios.get("/mfin/listaKategorijaZaZahtev", {
    params: { brojZahteva },
  });
};

const postMfListaEvidentiranihAkciznihMarkica = (
  payload: MfinListaEvidentiranihAkciznihMarkicaPayload
): Promise<ApiResponseObject<MfinListaEvidentiranihAkciznihMarkicaResponse>> => {
  return axios.post("/mfin/mfListaEvidentiranihAkciznihMarkica", payload);
};

export const ministryRepo = {
  postMfSviZahteviZaMarkicu,
  postInformacijeNapravljenogZahtevaZaMarkicu,
  postMfObradiZahtevZaMarkicu,
  postMfListaAkciznihSkladista,
  postDetaljiOSkladistu,
  postMfObradiZahtevZaDozvolu,
  createDohvatiDokument,
  createDohvatiDokumentMfin,
  createMfListaAkciznihDozvola,
  createDetaljiZahtevaDozvole,
  createMfIzdavanjeResenja,
  poreskaDohvatiDokument,
  createMfIzdavanjeResenjaOOduzimanju,
  generisiDozvolaZahtevDokument,
  postMfSveMarkiceVracenih,
  postMfMarkiceVraceneCreateOrUpdate,
  postMfMarkcieVraceneInsertUnistenje,
  postMfMarkiceVraceneDelete,
  getMfListaKategorijaZaZahtev,
  postMfListaEvidentiranihAkciznihMarkica,
};
